<template>
	<a-modal title="联系项目方" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="functionId" name="functionId">
					<a-input v-model:value="form.functionId" />
				</a-form-item>
			</div>
			<a-form-item label="姓名" name="name">
				<a-input v-model:value="form.name" placeholder="请输入" />
			</a-form-item>
			<a-form-item label="联系电话" name="mobilePhone">
				<a-input v-model:value="form.mobilePhone" placeholder="请输入" />
			</a-form-item>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { achievementFontInfo } from "@/api/achievementsService";

export default {
	name: "corpProjectModal",
	components: { },
	mixins: [formMixin],
	data() {
		return {
			form: {
				achievementsId: null,
			},
			rules: {
				mobilePhone: [dataCheck.required({}), dataCheck.mobile_phone],
				name: [dataCheck.required({})],
				functionId: []
			},
			submitUrl: achievementFontInfo.save
		}
	},
}
</script>
<style scoped lang="less"></style>
